import React from "react";
import Section from "@/components/ui/section";
import Image from "next/image";
import cn from "classnames";
export default function WhatWeDo({ reverse, title, content, image, id }) {
  return (
    <Section className={"bg-[#F4F9FF]"} variant="flat" id={id}>
      <div
        className={cn("flex lg:gap-12 gap-6 w-full mx-auto", {
          "lg:flex-row-reverse flex-col-reverse items-center": reverse,
          "lg:flex-row flex-col-reverse items-center": !reverse,
        })}
      >
        <div className="flex flex-col gap-3">
          <h2 className="text-darkBlue w-fit border-b-[2px] border-blue mb-2 text-center mx-auto">
            {title ?? "The Problem"}
          </h2>
          {content && (
            <div className="text-body md:text-base text-sm text-center flex flex-col gap-4">
              {content}
            </div>
          )}
        </div>
      </div>
    </Section>
  );
}
